<template>
    <div class="case-column">
        <listSkeleton v-if="isLoading"> </listSkeleton>
        <div class="case-column-header" v-else>
            <div class="case-column-header-warpper">
                <img class="case-column-header-warpper-tips" src="/static/v4/assembly/icon_list_tag_column.svg" alt="" />
                <span class="case-column-header-warpper-title">{{ pageInfo.title }}</span>
                <div class="case-column-header-warpper-info">已更新{{ pageInfo.current_count }}篇 | 共{{ pageInfo.total_count }}篇</div>
            </div>

            <van-button type="primary" @click="handleStatus(pageInfo)" v-if="!pageInfo.is_subscribe">
                <img src="@/assets/medical/medical-follow.svg" />
                关注
            </van-button>
            <van-button @click="handleStatus(pageInfo)" v-else>
                <img src="@/assets/medical/medical-follow.svg" />
                已关注
            </van-button>
        </div>

        <div class="case-column-content">
            <div class="case-column-content-list" v-if="channelList && channelList.length">
                <van-list v-if="channelList" v-model="loading" :finished="finished" finished-text="已到底部" :immediate-check="false" @load="onLoad">
                    <Article v-for="item in channelList" :key="item.id" :dataItem="item" :wapperFn="true" @goDetail="goDetail(item)" />
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import listSkeleton from '@/skeleton/listSkeleton'
import Article from './article.vue'
export default {
    components: {
        Article,
        listSkeleton
    },
    data() {
        return {
            loading: true,
            finished: false,
            isLoading: true,
            channelList: [],
            page: {
                page: 1,
                pageSize: 10
            },
            total: 0,
            type: false,
            pageID: null,
            pageInfo: null
        }
    },
    created() {
        this.fetch('channelList')
        this.fetch('info')
    },
    methods: {
        handleStatus(row) {
            if (!row.is_subscribe) {
                this.pageID = row.id
                this.fetch('subscribe')
                return
            }
            this.$dialog
                .confirm({
                    title: '提醒',
                    message: '确定取消关注吗？',
                    confirmButtonText: '确定',
                    className: 'dly-dialog'
                })
                .then(() => {
                    this.type = true
                    this.pageID = row.id
                    this.fetch('subscribe')
                })
                .catch(() => {
                    console.log(1)
                })
        },
        onLoad() {
            this.finished = false
            this.loading = true
            this.page.page++
            this.fetch('channelList')
        },
        goDetail(row) {
            this.$router.push({
                name: 'article-detail',
                params: { id: row.id }
            })
        },
        fetch(scene) {
            if (scene === 'subscribe') {
                Interface.getData('get', Interface.medical.subscribe + this.pageID).then(res => {
                    if (res.code === 0) {
                        if (this.type) {
                            this.$toast.success('取消关注成功')
                            this.type = false
                            this.pageID = null
                        } else {
                            this.$toast.success('关注成功')
                        }
                        this.page.page = 1
                        this.fetch('channelList')
                        this.channelList = []
                    } else {
                        this.$toast(res.message)
                    }
                })
            } else if (scene === 'channelList') {
                Interface.getData('get', Interface.medical.followList + this.$route.params.id, this.page).then(res => {
                    this.channelList = [...this.channelList, ...res.data.list]
                    this.total = res.data.total
                    this.loading = false
                    this.isLoading = false

                    if (this.channelList.length >= this.total) {
                        this.finished = true
                    }
                })
            } else if (scene === 'info') {
                Interface.getData('get', '/course/api/article/detail/' + this.$route.params.id).then(res => {
                    this.pageInfo = res.data
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/case/column/index.vue